import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Attachment } from 'src/app/models/server/attachment';
import { FolderDocument } from 'src/app/models/server/folder-document';
import { FolderDocumentsService } from '../http/folder-documents.service';

@Injectable()
export class FavoriteDocumentsStateService {
    private onFavoriteDocumentChange = new BehaviorSubject<FolderDocument>(null);

    private onAttachmentFavoriteStatusChange = new BehaviorSubject<Attachment>(null);

    /**
     * Emet un événement lorsque le document contenant les favoris change.
     */
    public get onFavoriteDocumentChange$() {
        return this.onFavoriteDocumentChange.asObservable();
    }

    /**
     * Emet un événement lorsque le status de favori d'une pièce-jointe change.
     */
    public get onAttachmentFavoriteStateChange$() {
        return this.onAttachmentFavoriteStatusChange.asObservable();
    }

    /**
     * Retourne le document "virtuel" contenant les favoris.
     */
    public get getFavoriteDocument(): FolderDocument {
        return this.onFavoriteDocumentChange.value;
    }

    constructor(private foldersDocumentsService: FolderDocumentsService) {}

    /**
     * Ajoute une pièce-jointe aux favoris.
     */
    public AddFavoriteAttachment(viewId: number, folderId: string, attachment: Attachment) {
        let favoriteDocument = this.onFavoriteDocumentChange.value;

        if (favoriteDocument) {
            this.foldersDocumentsService.markAttachmentAsFavorite(viewId, folderId, attachment.documentId, attachment.id, attachment.isFavorite).subscribe((x) => {
                attachment.isFavorite = x.isFavorite;
                favoriteDocument.attachments.push(attachment);
                this.changeFavoriteDocument(favoriteDocument);
                this.changeAttachmentFavoriteStatus(attachment);
            });
        }
    }

    /**
     * Retire une pièce-jointe des favoris.
     */
    public RemoveFavoriteAttachment(viewId: number, folderId: string, attachment: Attachment) {
        let favoriteDocument = this.onFavoriteDocumentChange.value;

        if (favoriteDocument) {
            this.foldersDocumentsService.markAttachmentAsFavorite(viewId, folderId, attachment.documentId, attachment.id, attachment.isFavorite).subscribe((x) => {
                attachment.isFavorite = x.isFavorite;
                this.removeFavoriteAttachmentFromVirtualDocument(attachment);
                this.changeAttachmentFavoriteStatus(attachment);
            });
        }
    }

    public removeFavoriteAttachmentFromVirtualDocument(attachment: Attachment) {
        let favoriteDocument = this.onFavoriteDocumentChange.value;

        let favoriteIndex = favoriteDocument.attachments.findIndex((x) => x.id === attachment.id);
        favoriteDocument.attachments.splice(favoriteIndex, 1);
        this.changeFavoriteDocument(favoriteDocument);
    }

    private changeFavoriteDocument(document: FolderDocument) {
        this.onFavoriteDocumentChange.next(document);
    }

    private changeAttachmentFavoriteStatus(attachment: Attachment) {
        this.onAttachmentFavoriteStatusChange.next(attachment);
    }

    public initFavoriteDocument(document: FolderDocument) {
        this.onFavoriteDocumentChange.next(document);
    }
}
